import { ChakraProvider } from "@chakra-ui/react";
import React from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import "./App.css";
import ClientDetail from "./components/ClientDetail/ClientDetail";
import Clients from "./components/Clients";
import Header from "./components/Shared/Header";
import SignIn from "./components/Shared/SignIn";
import { AuthProvider, useAuth } from "./Contexts/AuthContext";
import { DataProvider } from "./Contexts/DataContext";
import theme from "./theme";
import { ResponsiveProvider } from "./Contexts/ResponsiveContext";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) return null;

  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  return children;
};

function App() {
  return (
    <ChakraProvider theme={theme}>
      <Router>
        <ResponsiveProvider>
          <AuthProvider>
            <DataProvider>
              <Routes>
                {/* Protected Routes with Header */}
                <Route
                  path="/client-portal"
                  element={
                    <ProtectedRoute>
                      <>
                        <Header />
                        <ClientDetail />
                      </>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/clients"
                  element={
                    <ProtectedRoute>
                      <>
                        <Header />
                        <Clients />
                      </>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <>
                        <Header />
                        <Clients />
                      </>
                    </ProtectedRoute>
                  }
                />

                {/* Public Route */}
                <Route path="/signin" element={<SignIn />} />
              </Routes>
            </DataProvider>
          </AuthProvider>
        </ResponsiveProvider>
      </Router>
    </ChakraProvider>
  );
}

export default App;
